import React, { memo } from "react";

const BreadcrumbSeparatorIcon: React.FC = memo(() => {
  return (
    <svg
      width="4"
      height="6"
      viewBox="0 0 4 6"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.621996 5.878C0.540666 5.79668 0.5 5.69809 0.5 5.58223C0.5 5.46636 0.540666 5.36777 0.621996 5.28645L2.90843 3L0.621996 0.713551C0.540666 0.632229 0.5 0.533637 0.5 0.417774C0.5 0.30191 0.540666 0.203318 0.621996 0.121997C0.703318 0.0406657 0.80191 0 0.917774 0C1.03364 0 1.13223 0.0406657 1.21355 0.121997L3.7364 2.64485C3.78894 2.69738 3.82601 2.75279 3.84759 2.81109C3.86918 2.86938 3.87998 2.93235 3.87998 3C3.87998 3.06765 3.86918 3.13062 3.84759 3.18891C3.82601 3.24721 3.78894 3.30262 3.7364 3.35515L1.21355 5.878C1.13223 5.95933 1.03364 6 0.917774 6C0.80191 6 0.703318 5.95933 0.621996 5.878Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { BreadcrumbSeparatorIcon };
